//-----------------------------|| LIST ||---------------------------------------------------------------
export const SET_FARM_RECORD_LIST = 'SET_FARM_RECORD_LIST';
export const CLEAR_FARM_RECORD_LIST = 'CLEAR_FARM_RECORD_LIST';
export const FARM_RECORD_LIST_PENDING = 'FARM_RECORD_LIST_PENDING';
export const FARM_RECORD_LIST_ERROR = 'FARM_RECORD_LIST_ERROR';
export const FARM_RECORD_LIST_ERROR_CLEAR = 'FARM_RECORD_LIST_ERROR_CLEAR';

//-----------------------------|| FILTER ||-------------------------------------------------------------
export const FARM_RECORDS_FILTER_DIALOG_OPEN = 'FARM_RECORDS_FILTER_DIALOG_OPEN';
export const FARM_RECORDS_FILTER_DIALOG_CLOSE = 'FARM_RECORDS_FILTER_DIALOG_CLOSE';
export const SET_FARM_RECORDS_FILTER_DATA = 'SET_FARM_RECORDS_FILTER_DATA';

//-----------------------------|| OVERALL SUMMARY ||----------------------------------------------------
export const SET_OVERALL_SUMMARY = 'SET_OVERALL_SUMMARY';
export const CLEAR_OVERALL_SUMMARY = 'CLEAR_OVERALL_SUMMARY';
export const OVERALL_SUMMARY_PENDING = 'OVERALL_SUMMARY_PENDING';
export const OVERALL_SUMMARY_ERROR = 'OVERALL_SUMMARY_ERROR';
export const OVERALL_SUMMARY_ERROR_CLEAR = 'OVERALL_SUMMARY_ERROR_CLEAR';

//-----------------------------|| EXPORT ||-------------------------------------------------------------
export const FARM_RECORDS_EXPORT_PENDING = 'FARM_RECORDS_EXPORT_PENDING';
export const FARM_RECORDS_EXPORT_ERROR = 'FARM_RECORDS_EXPORT_ERROR';
export const FARM_RECORDS_EXPORT_ERROR_CLEAR = 'FARM_RECORDS_EXPORT_ERROR_CLEAR';

//-----------------------------|| DETAILS ||------------------------------------------------------------
export const SET_FARM_RECORD_DETAILS = 'SET_FARM_RECORD_DETAILS';
export const CLEAR_FARM_RECORD_DETAILS = 'CLEAR_FARM_RECORD_DETAILS';
export const FARM_RECORD_DETAILS_PENDING = 'FARM_RECORD_DETAILS_PENDING';
export const FARM_RECORD_DETAILS_ERROR = 'FARM_RECORD_DETAILS_ERROR';
export const FARM_RECORD_DETAILS_ERROR_CLEAR = 'FARM_RECORD_DETAILS_ERROR_CLEAR';

//-----------------------------|| LAB RECORDS LIST ||---------------------------------------------------
export const SET_LAB_RECORDS = 'SET_LAB_RECORDS';
export const CLEAR_LAB_RECORDS = 'CLEAR_LAB_RECORDS';
export const LAB_RECORDS_PENDING = 'LAB_RECORDS_PENDING';
export const LAB_RECORDS_ERROR = 'LAB_RECORDS_ERROR';
export const LAB_RECORDS_ERROR_CLEAR = 'LAB_RECORDS_ERROR_CLEAR';
